import { EBusinessEntityStep } from '../../types/businessEntityFlow/step';

export function getBusinessEntityFlowSteps() {
  return [
    EBusinessEntityStep.BusinessEntityCheckData,
    EBusinessEntityStep.BusinessEntityForm,
    EBusinessEntityStep.Insurance,
    EBusinessEntityStep.Success,
    EBusinessEntityStep.Error,
  ];
}
